import { z } from 'zod';

import { ApiPrivacyConsentConfigurationCategoriesSchema } from './categories';
import { ApiPrivacyConsentConfigurationGeolocationSchema } from './geolocation';
import { ApiPrivacyConsentConfigurationLocateSchema } from './locate';
import { ApiPrivacyConsentConfigurationMappingsSchema } from './mappings';

export const ApiPrivacyConsentConfigurationSchema = z.object({
  /** Wether this cofiguration needs a confirmation dialog to confirm the mappings */
  locate: ApiPrivacyConsentConfigurationLocateSchema,
  geolocation: ApiPrivacyConsentConfigurationGeolocationSchema.optional(),
  mappings: z.array(ApiPrivacyConsentConfigurationMappingsSchema),
  categories: z.array(ApiPrivacyConsentConfigurationCategoriesSchema),
});

type ApiPrivacyConsentConfiguration = z.infer<typeof ApiPrivacyConsentConfigurationSchema>;

export default ApiPrivacyConsentConfiguration;
